import {
  Currencies,
  DateFilterType,
  FetchItemCacheKey,
  FetchItemGqlQuery,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  ID,
  IdFilterType,
  MoneyType,
  TextFilterType
} from '../../types';

export type CurrencyRateID = ID;
export type CurrencyRateBaseCurrency = Currencies;
export type CurrencyRateData = Record<Currencies, MoneyType>;

export type FetchCurrencyRatesFilters = {
  createdAt?: DateFilterType;
  id?: IdFilterType;
  updatedAt?: DateFilterType;
  userId?: IdFilterType;
  source?: TextFilterType;
};

export enum FetchCurrencyRatesSortTypes {
  ID_DESC = 'ID_DESC'
}

export enum CurrencyRatesSource {
  EXCHANGERATE_API = 'exchangerate-api.com',
  CUSTOM = 'custom'
}

export type FetchCurrencyRatesLimit = FetchItemsLimit;
export type FetchCurrencyRatesSort = FetchCurrencyRatesSortTypes[];
export type FetchCurrencyRatesGqlQuery = FetchItemsGqlQuery;
export type FetchCurrencyRatesCacheKey = FetchItemsCacheKey;

export type FetchLastDefaultCurrencyRateGqlQuery = FetchItemGqlQuery;
export type FetchLastDefaultCurrencyRateCacheKey = FetchItemCacheKey;

export type FetchCacheLastDefaultCurrencyRateGqlQuery = FetchItemGqlQuery;
export type FetchCacheLastDefaultCurrencyRateCacheKey = FetchItemCacheKey;
